import { Routes, Route } from 'react-router-dom';
import GrantList from './GrantList';

/**
 * 授权子模块路由。列表 / 新建授权抽屉均在列表页内呈现，
 * 对外只暴露挂载点 `/iam/grants/*`。
 */
export default function IamGrantsRoutes() {
  return (
    <Routes>
      <Route index element={<GrantList />} />
    </Routes>
  );
}
